import { axiosApi } from "../api/axiosApi";
import { BlogType, CaseStudy } from "../types/types";

export const handleGetCaseStudies = async (
  currentPage: number,
  limit: number,
): Promise<{
  data: CaseStudy[] | null;
  status: number;
  meta: any;
}> => {
  try {
    const response = await axiosApi.get("/psyche-case-studies", {
      params: {
        populate: {
          cover: {
            populate: "*",
          },
          psyche_categories: {
            populate: "*",
          },
        },
        pagination: {
          page: currentPage,
          pageSize: limit,
        },
      },
    });

    if (response.status === 200) {
      return {
        data: response.data.data,
        meta: response.data.meta,
        status: response.status,
      };
    }


  } catch (error) {
    console.error("Error:", error);
  }
  return { data: null, meta: null, status: 500 };
};

export const handleGetCaseStudyBySlug = async (
  slug: string,
): Promise<{
  data: CaseStudy | null;
  status: number;
}> => {
  try {
    const response = await axiosApi.get(`/psyche-case-studies`, {
      params: {
        "filters[slug][$eq]": slug,
        populate: "*",
      },
    });

    if (response.status === 200) {
      return { data: response.data.data[0], status: response.status };
    }
  } catch (error) {
    console.error("Error:", error);
  }
  return { data: null, status: 500 };
};

export const handleGetBlogs = async (
  currentPage: number,
  limit: number,
): Promise<{
  data: BlogType[] | null;
  status: number;
  meta: any;
}> => {
  try {
    const response = await axiosApi.get("/psyche-ethos-blogs", {
      params: {
        populate: {
          cover: {
            populate: "*",
          },
          psyche_author: {
            populate: "*",
          },
        },
        pagination: {
          page: currentPage,
          pageSize: limit,
        },
      },
    });

    if (response.status === 200) {
      return {
        data: response.data.data,
        meta: response.data.meta,
        status: response.status,
      };
    }
  } catch (error) {
    console.error("Error:", error);
  }
  return { data: null, meta: null, status: 500 };
};

export const handleGetBlogBySlug = async (
  slug: string,
): Promise<{
  data: BlogType | null;
  status: number;
}> => {
  try {
    const response = await axiosApi.get(`/psyche-ethos-blogs`, {
      params: {
        "filters[slug][$eq]": slug,
        populate: "*",
        psyche_author: {
          populate: "*",
        },
      },
    });

    if (response.status === 200) {
      return { data: response.data.data[0], status: response.status };
    }
  } catch (error) {
    console.error("Error:", error);
  }
  return { data: null, status: 500 };
};
